export const ADD_NOTE = 'ADD_NOTE';
export const CLEAR_NOTE = 'CLEAR_NOTE';
export const SEND_NEW_NOTE = 'SEND_NEW_NOTE';
export const SET_NOTES = 'SET_NOTES';